export default function MobileBurgerMenu() {
	// mobile burger menu
	let burger = document.querySelector( '.burger-button' );
	let menu_body = document.querySelector( '#header-menu' );
	if ( burger ) {
		burger.onclick = function () {
			menu_body.classList.toggle( 'active' );
			burger.classList.toggle( 'active' )
		}
	}
}